import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const CommsCenter = withLazyFallback(() => import('components/practice/comms_center/CommsCenter'));
const ContactsPage = withLazyFallback(
  () => import('components/practice/comms_center/Contacts/ContactsPage')
);
const NewArchivedFaxes = withLazyFallback(
  () => import('components/practice/comms_center/fax/ArchivedFaxes/NewArchivedFaxes')
);

const DraftFaxes = withLazyFallback(
  () => import('components/practice/comms_center/fax/Drafts/DraftFaxes')
);
const Fax = withLazyFallback(() => import('components/practice/comms_center/fax/Fax/Fax'));
const NewInboundFaxes = withLazyFallback(
  () => import('components/practice/comms_center/fax/InboundFaxes/NewInboundFaxes')
);
const Main = withLazyFallback(() => import('components/practice/comms_center/fax/Main/Main'));
const NewOutboundFaxes = withLazyFallback(
  () => import('components/practice/comms_center/fax/OutboundFaxes/NewOutboundFaxes')
);

const PRACTICE_COMMS_CENTER = [
  {
    path: 'comms-center',
    element: <CommsCenter />,
    children: [
      {
        path: '',
        element: <Fax />,
        children: [
          { path: '', element: <Main /> },
          { path: 'inbound', element: <NewInboundFaxes /> },
          { path: 'outbound', element: <NewOutboundFaxes /> },
          { path: 'drafts', element: <DraftFaxes /> },
          { path: 'Archived', element: <NewArchivedFaxes /> }
        ]
      },
      { path: 'contacts', element: <ContactsPage /> }
    ]
  }
];

export default PRACTICE_COMMS_CENTER;
